import { BoostWishClient, DisableListClient, KakeraLootsClient, UtilityClient } from "./client";

//var url = 'https://localhost:7177'
var url = 'https://mudae-utils-api.azurewebsites.net'

export const BoostWishApi = new BoostWishClient(url);
export const DisableListApi = new DisableListClient(url);
export const KakeraLootsApi = new KakeraLootsClient(url);
export const UtilityApi = new UtilityClient(url);
